module.exports = __webpack_public_path__ + "img/13_16.bac2422d.png";